import React, { Component } from "react";
import { connect } from "react-redux";
// import isEqual from "lodash/isEqual";

import withStyles from "@material-ui/styles/withStyles";

import {
  Create,
  MultiCardForm,
  FormDataConsumer,
  ArrayInput,
  SimpleFormIterator,
  FormCard,
  TextInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  AutoCompleteInput,
  AutoCompleteArrayInput,
  required,
  minLength,
  RestMethods,
  crudGetList,
  showNotification,
} from "jazasoft";
import { SimpleForm } from "jazasoft/lib/mui/form/SimpleForm";
import { Role } from "../../utils/types";

import { dataProvider } from "../../App";

const Div = (props) => <div />;

const inputOptions = (sm) => ({
  xs: 12,
  sm,
  fullWidth: true,
  options: { fullWidth: true },
});

const styles = {
  root: {},
};

class UserCreate extends Component {
  state = {
    config: {},
  };

  componentDidMount() {
    this.props.dispatch(crudGetList("roles", { page: 0, pageSize: 100 }));
    this.props.dispatch(crudGetList("apps", { page: 0, pageSize: 100 }));
    this.fetchConfigAsync();
  }

  fetchConfigAsync = async () => {
    const options = {
      url: "permissions/configs",
      method: "get",
    };
    try {
      const response = await dataProvider(RestMethods.CUSTOM, null, options);
      this.setState({ config: response.data });
    } catch (e) {
      console.log(e);
    }
  };

  onChange = (values, dispatch, props, prevValues) => {
    // if (values.tenantId !== prevValues.tenantId) {
    //   const keys = values.apps && values.apps.map((_, idx) => `apps[${idx}].permissionIds`);
    //   dispatch(props.resetSection(keys[0], keys[1], keys[2], keys[3], keys[4], keys[5], keys[6], keys[7], keys[8], keys[9]));
    // }
    // const appIds = values.apps && values.apps.map(app => app.id);
    // const prevAppIds = prevValues.apps && prevValues.apps.map(app => app.id);
    // if (appIds && prevAppIds && !isEqual(appIds, prevAppIds)) {
    //   const n = appIds.length > prevAppIds.length ? appIds.length : prevAppIds.length;
    //   for (let i = 0; i < n; i++) {
    //     if (appIds[i] !== prevAppIds[i]) {
    //       if (prevAppIds[i] !== undefined && appIds[i] !== undefined) {
    //         dispatch(props.change(`apps[${i}].permissionIds`, []));
    //       }
    //     }
    //   }
    // }
  };

  onValidate = (values) => {
    const { apps = [] } = values;
    let hasError = false;
    const appList = apps.map((app) => {
      const roleIds =
        app.roleIds
          ?.map((id) => this.props.roleList.find((r) => r.id === id))
          .filter((e) => !!e)
          .map((r) => r.roleId) || [];
      if (roleIds.includes(Role.ADMIN) && roleIds.length > 1) {
        hasError = true;
        return { roleIds: "User cannot have any other role along with Admin Role" };
      }
      return {};
    });
    if (hasError) {
      this.props.dispatch(showNotification("User cannot have any other role along with Admin Role.", { type: "danger" }));
    }
    let errors = { apps: appList };
    return errors;
  };

  parse = ({ apps, ...record }) => {
    let appList = apps.map(({ id, roleIds, ...rest }) => {
      const rIds =
        roleIds
          ?.map((id) => this.props.roleList.find((r) => r.id === id))
          .filter((e) => !!e)
          .map((r) => r.roleId) || [];
      if (rIds.includes(Role.ADMIN)) {
        return { id, roleIds };
      }
      return { id, roleIds, ...rest };
    });
    return { ...record, apps: appList };
  };

  render() {
    const { classes, formData = {}, apps, tenants, permissions, roleList, authState = {}, dispatch, ...props } = this.props;
    const roles = this.props.roles || [];
    const config = this.state.config || {};
    const appList = apps && formData.apps && formData.apps.map(({ id }) => apps[id]).filter((e) => !!e);
    let tenant = tenants && formData.tenantId && tenants[formData.tenantId];

    let initialValues = { apps: [{}] };
    if (!roles.includes(Role.MASTER)) {
      tenant = authState.tenant || {};
      initialValues = { ...initialValues, tenantId: tenant.id };
    }
    let choicesApp = tenant && tenant.appList ? tenant.appList : [];
    if (roles.includes(Role.ADMIN)) {
      choicesApp = authState.appList ? authState.appList : [];
    }
    let permissionList = appList?.flatMap((app) => config[app.appId] && config[app.appId].map((p) => ({ ...p, id: app.id, appId: app.appId }))) || [];
    const roleMaster = roleList.find((r) => r.roleId === Role.MASTER) || {};
    const roleAdmin = roleList.find((r) => r.roleId === Role.ADMIN) || {};
    const permissionKeys = permissionList.filter((p) => p && p.type === "PER_USER");
    return (
      <Create cardWrapper={false} record={initialValues} parse={this.parse} {...props}>
        <MultiCardForm onChange={this.onChange} validate={this.onValidate} redirect="home">
          <FormCard title="User Info">
            <TextInput source="fullName" validate={[required(), minLength(2)]} {...inputOptions(3)} />
            <TextInput source="username" validate={[required()]} {...inputOptions(3)} />
            <TextInput source="email" {...inputOptions(3)} />
            <TextInput source="mobile" validate={[required()]} {...inputOptions(3)} />
            {roles.includes(Role.MASTER) && (
              <SelectInput
                source="roleId"
                choices={roleList.filter((r) => ["master", "super_user"].includes(r.roleId))}
                allowEmpty
                {...inputOptions(3)}
              />
            )}
            {(!formData.roleId || formData.roleId !== roleMaster.id) && roles.includes(Role.MASTER) && (
              <ReferenceInput source="tenantId" reference="tenants" validate={[required()]} {...inputOptions(3)}>
                <AutoCompleteInput />
              </ReferenceInput>
            )}
          </FormCard>
          {!formData.roleId ? (
            <FormCard title="Apps">
              <ArrayInput source="apps" fullWidth={true} xs={12}>
                <SimpleFormIterator>
                  <SelectInput label="App" source="id" choices={choicesApp} {...inputOptions(3)} />
                  <FormDataConsumer {...inputOptions(3)}>
                    {({ formData, source }) => {
                      let idx = source && source.split(".")[0].substring(5);
                      idx = idx.substring(0, idx.length - 1);
                      const appId = formData.apps && formData.apps[idx] && formData.apps[idx].id;
                      const choices = roleList.filter((r) => r.roleId === Role.ADMIN || r.appId === appId);
                      return (
                        <AutoCompleteArrayInput
                          label="Roles"
                          source={`${source.split(".")[0]}.roleIds`}
                          choices={choices}
                          validate={[required()]}
                          {...inputOptions(3)}
                        />
                      );
                    }}
                  </FormDataConsumer>

                  <FormDataConsumer {...inputOptions(12)}>
                    {({ formData, source }) => {
                      let idx = source && source.split(".")[0].substring(5);
                      idx = idx.substring(0, idx.length - 1);
                      const appId = formData.apps && formData.apps[idx] && formData.apps[idx].id;
                      const roleIds = formData.apps && formData.apps[idx] && formData.apps[idx].roleIds;
                      if (roleIds && roleIds.includes(roleAdmin.id)) return null;

                      return (
                        <SimpleForm component="div" footer={false}>
                          {permissionKeys
                            .filter((p) => p.id === appId)
                            .sort((a, b) => a.serialNo - b.serialNo)
                            .map((p) => {
                              let filter = {
                                "app.id": appId,
                                "tenant.id": tenant.id,
                                key: p.key,
                              };
                              if (p.parentKey) {
                                const parentPerm = permissionKeys.find((e) => e.key === p.parentKey);
                                const field = parentPerm && parentPerm.multiSelect ? `${p.parentKey}s` : p.parentKey;
                                const value = formData.apps[idx][field];
                                let parentValue = "-1";
                                if (value) {
                                  parentValue = parentPerm.multiSelect
                                    ? value
                                        .map((id) => permissions[id])
                                        .filter((e) => e)
                                        .map((e) => e.value)
                                    : permissions[value] && permissions[value].value;
                                }
                                filter = {
                                  ...filter,
                                  parentValue,
                                };
                              }

                              return p.multiSelect ? (
                                <ReferenceArrayInput
                                  key={`${appId}-${tenant.id}-${p.key}`}
                                  label={p.name}
                                  source={`${source.split(".")[0]}.${p.key}s`}
                                  reference="permissions"
                                  filter={filter}
                                  fullWidth
                                  options={{ fullWidth: true }}
                                  xs={12}
                                  sm={6}
                                >
                                  <AutoCompleteArrayInput />
                                </ReferenceArrayInput>
                              ) : (
                                <ReferenceInput
                                  key={`${appId}-${tenant.id}-${p.key}`}
                                  label={p.name}
                                  source={`${source.split(".")[0]}.${p.key}`}
                                  reference="permissions"
                                  filter={filter}
                                  fullWidth
                                  options={{ fullWidth: true }}
                                  xs={12}
                                  sm={3}
                                >
                                  <AutoCompleteInput />
                                </ReferenceInput>
                              );
                            })}
                        </SimpleForm>
                      );
                    }}
                  </FormDataConsumer>
                </SimpleFormIterator>
              </ArrayInput>
            </FormCard>
          ) : (
            <Div />
          )}
        </MultiCardForm>
      </Create>
    );
  }
}

const mapStateToProps = (state) => {
  const roles = (state.jazasoft.resources["roles"] && state.jazasoft.resources["roles"].data) || {};
  const roleList = Object.keys(roles).map((id) => roles[id]);
  return {
    roleList,
    authState: state.jazasoft.auth,
    formData: state.form && state.form["record-form"] && state.form["record-form"].values,
    permissions: state.jazasoft.resources["permissions"] && state.jazasoft.resources["permissions"].data,
    apps: state.jazasoft.resources["apps"] && state.jazasoft.resources["apps"].data,
    tenants: state.jazasoft.resources["tenants"] && state.jazasoft.resources["tenants"].data,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(UserCreate));
